// Quadro "Robô do e-mail" no fim do Envio de Contas: o que o robô da caixa prorrogacoes@ leu nos últimos
// 30 dias (api/_prorrogacoes-email.js) — principalmente os e-mails que ele não conseguiu ligar a um paciente
// ("para conferir"), para a equipe tratar à mão.
import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { buscarIW } from '../iw/apiIW';
import { P, chip, fmtDataHora, fmtMes } from './comum';

const DECISAO = {
  envio: ['Envio marcado', '#dbeafe', '#1e40af'],
  resposta: ['Resposta', '#dcfce7', '#166534'],
  conferir: ['Conferir', '#fef3c7', '#92400e'],
  ignorado: ['Ignorado', '#f1f5f9', '#475569'],
};
const CLASSIFICACAO = { aprovado: 'aprovada', negado: 'negada', devolutiva: 'devolutiva', recebido: 'recebimento', conferir: 'não deu para ler' };

export default function RoboEmail() {
  const [aberto, setAberto] = useState(false);
  const [dados, setDados] = useState(null);
  const [erro, setErro] = useState('');
  const [filtro, setFiltro] = useState('conferir');

  const abrir = async () => {
    const vai = !aberto;
    setAberto(vai);
    if (vai) {
      setErro('');
      try { setDados(await buscarIW('prorrogacoes?acao=emails')); } catch (e) { setErro(e.message); }
    }
  };

  const emails = dados?.emails || [];
  const conta = k => emails.filter(e => e.decisao === k).length;
  const lista = filtro ? emails.filter(e => e.decisao === filtro) : emails;
  const td = { padding: '6px 10px', borderTop: '1px solid #f1f5f9', fontSize: '0.76rem', color: P.text, verticalAlign: 'top' };

  return (
    <div style={{ background: P.white, border: `1px solid ${P.border}`, borderRadius: 14 }}>
      <button onClick={abrir} style={{ width: '100%', border: 'none', background: 'none', padding: '10px 14px', display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: '0.86rem', fontWeight: 800, color: P.text, textAlign: 'left' }}>
        {aberto ? <ChevronDown size={16} /> : <ChevronRight size={16} />} 📧 Robô do e-mail (caixa prorrogacoes@)
        {dados && <span style={{ fontWeight: 600, color: dados.ligado ? '#166534' : P.muted, fontSize: '0.76rem' }}>{dados.ligado ? `ligado · lendo desde ${dados.inicio}` : 'desligado'}</span>}
      </button>
      {aberto && (
        <div style={{ padding: '0 14px 12px' }}>
          {erro && <div style={{ background: '#fee2e2', color: '#991b1b', borderRadius: 8, padding: '6px 10px', fontSize: '0.8rem' }}>{erro}</div>}
          {!dados && !erro && <div style={{ color: P.muted, fontSize: '0.8rem' }}>Carregando…</div>}
          {dados && (
            <>
              <div style={{ fontSize: '0.76rem', color: P.muted, marginBottom: 8 }}>
                Últimos 30 dias. O robô só lê a caixa (não marca como lido, não move, não apaga) e nunca passa por cima do que a equipe marcou.
                "Conferir" = não deu para ligar o e-mail a um paciente/mês com segurança — trate à mão pelo botão Marcar.
              </div>
              <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 8 }}>
                {[['conferir', 'Para conferir'], ['envio', 'Envios marcados'], ['resposta', 'Respostas'], ['ignorado', 'Ignorados'], ['', 'Todos']].map(([k, l]) => (
                  <button key={k || 'todos'} onClick={() => setFiltro(k)}
                    style={{ border: `1px solid ${filtro === k ? P.primary : P.border}`, background: filtro === k ? '#eef2ff' : P.white, color: filtro === k ? P.primary : P.muted, borderRadius: 999, padding: '4px 12px', fontSize: '0.76rem', fontWeight: 700, cursor: 'pointer' }}>
                    {l} · {k ? conta(k) : emails.length}
                  </button>
                ))}
              </div>
              <div style={{ overflowX: 'auto', maxHeight: 420, overflowY: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 900 }}>
                  <tbody>
                    {lista.length === 0 && <tr><td style={{ ...td, color: P.muted, textAlign: 'center', padding: 18 }}>Nada aqui.</td></tr>}
                    {lista.map((e, i) => {
                      const [l, f, c] = DECISAO[e.decisao] || [e.decisao, '#f1f5f9', '#475569'];
                      return (
                        <tr key={i}>
                          <td style={{ ...td, whiteSpace: 'nowrap', color: P.muted }}>{fmtDataHora(e.recebido_em)}</td>
                          <td style={td}><span style={chip(f, c)}>{l}</span></td>
                          <td style={{ ...td, maxWidth: 420 }}>{e.assunto}<div style={{ color: P.muted, fontSize: '0.7rem' }}>{e.de}</div></td>
                          <td style={{ ...td, maxWidth: 360 }}>
                            {e.paciente && <div style={{ fontWeight: 700 }}>{e.paciente}{e.periodo ? ` · ${fmtMes(e.periodo)}` : ''}</div>}
                            {e.detalhe?.classificacao && <div>leitura: {CLASSIFICACAO[e.detalhe.classificacao] || e.detalhe.classificacao}</div>}
                            {e.detalhe?.acao && <div style={{ color: P.muted }}>{e.detalhe.acao}</div>}
                            {e.motivo && <div style={{ color: '#92400e' }}>{e.motivo}</div>}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}
